import { GetTemplateResponseSchema, ListResponseBody } from '@schuettflix/interfaces';
import { z } from 'zod';
import { useHttpClientContext } from '@/shared/context/HttpClientContext.tsx';

export const useGetTemplate = () => {
    const { orderClient } = useHttpClientContext();
    return {
        getTemplate: async (templateId: string) => {
            return orderClient
                .get<ListResponseBody<z.input<typeof GetTemplateResponseSchema>>>(`/v1/templates/${templateId}`)
                .then(response => GetTemplateResponseSchema.parse(response.data));
        },
    };
};
